'use client';

import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { ButtonGroup } from "../ButtonGroup/ButtonGroup.js";
import { classNames } from "../../utils/styles/classNames.js";
import { shouldOmitFooter } from "./utils/shouldOmitFooter.js";
import { bottomBorderRadius, footer } from "./Modal.css.js";
function Footer({ primaryAction, secondaryAction }) {
  if (shouldOmitFooter({ primaryAction, secondaryAction })) return null;
  const buttons = useMemo(() => {
    const agg = [];
    if (secondaryAction == null ? void 0 : secondaryAction.label) {
      agg.push({ ...secondaryAction, variant: "default" });
    }
    const primaryVariant = (primaryAction == null ? void 0 : primaryAction.variant) ?? "primary";
    if (primaryAction == null ? void 0 : primaryAction.label) {
      agg.push({ ...primaryAction, variant: primaryVariant });
    }
    return agg;
  }, [primaryAction, secondaryAction]);
  return /* @__PURE__ */ jsx("div", { className: classNames(footer, bottomBorderRadius), children: /* @__PURE__ */ jsx(ButtonGroup, { buttons, orientation: "dynamic", size: "sm" }) });
}
export {
  Footer
};
